import { Directive, ElementRef, HostListener, OnInit } from '@angular/core';

@Directive({
  selector: '[appExpandableContent]'
})
export class ExpandableContentDirective implements OnInit {
  @HostListener('window:resize')
  onResize() {
    const maxHeight = parseInt(this.element.nativeElement.style.maxHeight, 10);

    if (maxHeight > 0 && maxHeight !== this.element.nativeElement.scrollHeight) {
      this.expand();
    }
  }

  constructor(private element: ElementRef<HTMLInputElement>) {}

  collapse() {
    this.element.nativeElement.style.maxHeight = '0';
  }

  expand() {
    this.element.nativeElement.style.maxHeight = `${this.element.nativeElement.scrollHeight}px`;
  }

  ngOnInit() {
    this.element.nativeElement.style.overflow = 'hidden';
    this.element.nativeElement.style.transition = 'max-height 0.5s ease-in-out';
  }
}
